<template>
  <header>
    <div class="top">
      <span class="logo fl">
        <img src="../assets/images/logo.png" alt />
        <!-- <img src="../assets/images/kqLogo.png" alt /> -->
      </span>
      <el-menu
        :default-active="$route.path"
        class="el-menu-demo navList fl"
        mode="horizontal"
        text-color="#333333"
        active-text-color="#409EFF"
        router
        @select="handleSelect"
      >
        <el-menu-item index="/home">学员报名</el-menu-item>
        <!-- <el-menu-item index="/train">培训证明</el-menu-item> -->
        <el-menu-item index="/queryStudent">学员查询</el-menu-item>
        <el-submenu index="2">
          <template slot="title">信息查询</template>
          <!-- <el-menu-item index="/queryStudent">学员报名查询</el-menu-item> -->
          <el-menu-item index="/queryRecord">培训记录查询</el-menu-item>
          <el-menu-item index="/queryExam">测试记录查询</el-menu-item>
          <!-- <el-menu-item index="/queryPractice">练习记录查询</el-menu-item> -->
          <el-menu-item index="/queryCourse">账号使用查询</el-menu-item>
          <el-menu-item index="/queryOrder">订单查询</el-menu-item>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">培训审核上报</template>
          <el-menu-item index="/trainAudit">培训审核</el-menu-item>
          <el-menu-item index="/trainAppear">培训上报</el-menu-item>
        </el-submenu>
        <!-- <el-submenu index="4">
          <template slot="title">数据统计</template>
          <el-menu-item index="/totalResult">练习成绩统计</el-menu-item>
          <el-menu-item index="/totalTime">学习时长统计</el-menu-item>
        </el-submenu>
        <el-menu-item index="/notice">通知管理</el-menu-item>
        <el-submenu index="5">
          <template slot="title">系统管理</template>
          <el-menu-item index="/log">操作日志</el-menu-item>
          <el-menu-item index="/upload">上传logo</el-menu-item>
        </el-submenu>-->
      </el-menu>
      <div class="right fr">
        <el-menu class="el-menu-demo">
          <el-submenu index="9">
            <template slot="title">
              <span class="name">{{ username }}</span>
              <img class="person" src="../assets/images/person.png" alt />
            </template>
            <el-menu-item index="9-1" @click="dialogVisible = true"
              >修改密码</el-menu-item
            >
            <el-menu-item index="9-2" @click="loginOut">退出登录</el-menu-item>
          </el-submenu>
        </el-menu>
        <!-- 修改密码弹框 -->
        <el-dialog
          title="修改企业登录密码"
          :visible.sync="dialogVisible"
          width="30%"
          center
          append-to-body
          @close="resetForm('ruleForm')"
        >
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            :rules="rules"
            label-width="100px"
          >
            <el-form-item label="旧密码：" prop="oldPass">
              <el-input
                type="password"
                v-model="ruleForm.oldPass"
                placeholder="请输入旧密码"
                autocomplete="off"
                show-password
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="新密码：" prop="pass">
              <el-input
                type="password"
                v-model="ruleForm.pass"
                placeholder="请输入新密码"
                autocomplete="off"
                show-password
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="checkPass">
              <el-input
                type="password"
                v-model="ruleForm.checkPass"
                placeholder="请输入确认密码"
                autocomplete="off"
                show-password
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item style="text-align: center">
              <el-button type="primary" @click="onSubmit('ruleForm')"
                >确认</el-button
              >
              <el-button plain @click="dialogVisible = false">取消</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
    </div>
  </header>
</template>

<script>
import http from "../api/module";
export default {
  // name: "header",
  data() {
    var checkOldPass = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入旧密码"));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入新密码"));
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(new Error("密码长度为6 - 18个字符"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      // activeIndex: "1"
      username: sessionStorage.getItem("username"),
      dialogVisible: false,
      ruleForm: {
        oldPass: "",
        pass: "",
        checkPass: "",
      },
      rules: {
        oldPass: [{ validator: checkOldPass, trigger: "blur" }],
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }],
      },
    };
  },
  methods: {
    /* 弹框表单清空 */
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    notice() {
      this.$router.push({
        path: "/notice",
      });
    },
    onSubmit(formName) {
      // this.dialogVisible = false;
      this.$refs[formName].validate((valid) => {
        console.log(valid, "valid");
        if (valid) {
          http
            .updatePassword({
              oldPassword: this.ruleForm.oldPass,
              newPassword: this.ruleForm.pass,
            })
            .then((data) => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message.success({
                  duration: 1000,
                  message: "密码修改成功！",
                });
                this.dialogVisible = false;
                setTimeout(() => {
                  this.$router.push({
                    path: "/",
                  });
                }, 2000);
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                duration: 1000,
                message: "请求失败，请联系管理员！",
              });
            });
        }
      });
    },
    loginOut() {
      http
        .logout({
          tokenId: sessionStorage.getItem("token"),
        })
        .then((data) => {
          if (data.data.code == "200" || data.data.success == true) {
            sessionStorage.removeItem("token");
            sessionStorage.clear();
            this.$message.success({
              duration: 1000,
              message: "已退出登录!",
            });
            setTimeout(() => {
              this.$router.push({
                path: "/login",
              });
            }, 300);
            sessionStorage.clear();
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message,
            });
          }
        })
        .catch((errror) => {});
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-menu-item,
/deep/.el-submenu__title {
  font-size: 16px;
}
/deep/.el-submenu__title {
  padding: 0;
}
/deep/.el-menu-demo.el-menu,
/deep/.el-submenu,
/deep/.el-submenu__title {
  height: 60px;
}
header {
  width: 100%;
  height: 60px;
  background: #ffffff;
  color: #333333;
  position: fixed;
  left: 0;
  top: 0;
  box-shadow: 0 0 5px 0 #ccc;
  z-index: 5;
  .top {
    height: 100%;
    padding: 0 20px;
  }
}
.logo {
  display: inline-block;
  width: 200px;
  height: 100%;
  position: relative;
  img {
    max-width: 90%;
    height: auto;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
.navList {
  line-height: 60px;
  li {
    float: left;
    // padding: 0 20px;
    color: #333333;
    cursor: pointer;
    &.active {
      color: #409eff;
    }
    &.router-link-exact-active {
      color: #409eff;
    }
  }
}
.right {
  /deep/.el-menu.el-menu--inline {
    width: 200px;
    float: right;
  }

  height: 60px;
  line-height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 160px;
  .name {
    color: #409eff;
    padding: 0 3px;
    margin-right: 10px;
  }
  .notice {
    display: inline-block;
    width: 28px;
    height: 28px;
    background: url("../assets/images/notice.png") no-repeat center;
    background-size: contain;
  }
  .person {
    width: 32px;
    height: 32px;
    margin-right: 20px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
